import { render, staticRenderFns } from "./BuildingPermitTemplate.vue?vue&type=template&id=5c4d2cca"
import script from "./BuildingPermitTemplate.vue?vue&type=script&lang=js"
export * from "./BuildingPermitTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports